module.exports = __webpack_public_path__ + "media/images/new_landing/people/johana-fundova-40d364adfe78fe9d3ffb5cf316198cc0.jpg";